// 추가 주문(16번)의 원 주문 고르기 — 자동 연결이 안 된 경우(후보 0건·2건 이상)만 보인다.
// 후보는 서버가 준다(serializers.addon_candidates: 회수완료·취소가 아닌 백일상, 일치 후보 먼저).
import React, { useState } from "react";

import api from "../../api";
import { formatDateShort } from "./format";

export default function AddonLinkPicker({ order, onLinked }) {
  const candidates = order.addon_candidates || [];
  const [parentId, setParentId] = useState(candidates[0]?.id || "");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  if (!order.is_addon || order.parent_info || order.status === "CANCELED") return null;
  if (candidates.length === 0) {
    return <div className="rental-addon-picker-empty">연결할 수 있는 백일상 주문이 없습니다</div>;
  }

  const link = async () => {
    if (!parentId) return;
    setBusy(true);
    setError("");
    try {
      await api.post(`rental/orders/${order.id}/link-parent/`, { parent_id: Number(parentId) });
      onLinked && (await onLinked());
    } catch (e) {
      setError(e?.response?.data?.detail || "원 주문을 연결하지 못했습니다.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="rental-addon-picker">
      <select
        className="rental-addon-select"
        value={parentId}
        onChange={(e) => setParentId(e.target.value)}
        disabled={busy}
      >
        {candidates.map((c) => (
          <option key={c.id} value={c.id}>
            {c.matched ? "★ " : ""}
            {c.order_id} · {c.receiver_name || "-"} · 배송 {formatDateShort(c.delivery_date)}
          </option>
        ))}
      </select>
      <button type="button" className="rental-btn-link" onClick={link} disabled={busy || !parentId}>
        {busy ? "연결 중…" : "원 주문 연결"}
      </button>
      {error && <div className="rental-error">{error}</div>}
    </div>
  );
}
